'use client';

import { flushSync } from 'react-dom';

import { Subject } from 'rxjs';

import {
  ProjectResponseModeEvent,
  useUtRemoteVoiceCommands,
} from '@/shared-survey';

interface Props {
  uniqueId: string | null;
  ingestTranscript: (transcript: string, isFinal: boolean) => void;
  eventsObservable: Subject<ProjectResponseModeEvent>;
  enabled?: boolean;
  isBlocked?: boolean;
}

export function useRemoteVoiceSubscription({
  uniqueId,
  ingestTranscript,
  eventsObservable,
  enabled = true,
  isBlocked = false,
}: Props): void {
  useUtRemoteVoiceCommands({
    uniqueId,
    enabled,
    isBlocked,
    onTurn: (action) => {
      // Flush the transcript refresh before firing so a command's downstream subscribers see the fresh transcript.
      flushSync(() => {
        ingestTranscript(action.transcript, action.isFinal);
      });

      if (action.command) {
        eventsObservable.next(action.command);
      }
    },
  });
}
